// make sure each enum value is proprtional to PortfolioSelectedFilterResource properties.
export enum PortfolioFilterType {
  Assignee = 'assignees',
  DealType = 'dealTypes',
  LastUpdate = 'lastUpdated',
  BpsValue = 'bpsValue',
  InMarketScore = 'inMarketScore',
  VehicleScore = 'vehicleScore',
  DealScore = 'dealScore',
  SoldBy = 'soldBy',
  Incentives = 'incentives',
  Colors = 'colors',
  OptOutPreference = 'optOutPreference',
  CurrentVehicleTrims = 'currentVehicleTrims',
  CurrentVehicleModels = 'currentVehicleModels',
  CurrentVehicleYears = 'currentVehicleYears',
  CurrentVehicleTypes = 'currentVehicleTypes',
  CurrentVehicleMileage = 'currentVehicleMileage',
  CurrentVehicleMakes = 'currentVehicleMakes',
  CurrentVehicleRate = 'currentVehicleRate',
  ReplacementVehicleSelection = 'replacementVehicleSelection',
  ReplacementVehicleTypes = 'replacementVehicleTypes',
  ReplacementVehicleTrims = 'replacementVehicleTrims',
  ReplacementVehicleModels = 'replacementVehicleModels',
  ReplacementVehicleYears = 'replacementVehicleYears',
  ReplacementVehicleMakes = 'replacementVehicleMakes',
  ReplacementVehicleMileage = 'replacementVehicleMileage',
  ReplacementVehicleRate = 'replacementVehicleRate',
  PaymentsRemaining = 'paymentsRemaining',
  IsTrimConfirmationRequired = 'isTrimConfirmationRequired',
  MonthsOfOwnership = 'monthsOfOwnership',
  Insights = 'insights',
  AgeDays = 'ageDays',
  Status = 'status',
  LastServiceDate = 'lastServiceDate',
  CampaignActivityViewCounts = 'campaignActivityViewCounts',
  Recall = 'recall',
  CampaignExpiryDates = 'campaignExpiryDates',
  FordIncentiveNames = 'fordIncentiveNames',
  ShopperActivity = 'shopperActivity',
}
